<div class="multi-checkbox-field">
  @if (props['label']) {
  <label class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }
  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }

  @if (checkboxOptions.length > 0) {
  <div class="multi-checkbox-actions">
    <app-button variant="text" size="sm" (click)="selectAll()" data-testid="multi-checkbox-select-all">
      {{ 'formly.multiCheckbox.selectAll' | translate }}
    </app-button>
    <app-button variant="text" size="sm" (click)="selectNone()" data-testid="multi-checkbox-select-none">
      {{ 'formly.multiCheckbox.selectNone' | translate }}
    </app-button>
  </div>
  }

  <div class="multi-checkbox-list">
    @for (option of checkboxOptions; track option.value) {
      <label class="multi-checkbox-item" [attr.data-testid]="'multi-checkbox-' + option.value">
        <input
          type="checkbox"
          [checked]="isChecked(option.value)"
          (change)="toggle(option.value)"
          [attr.data-testid]="'multi-checkbox-input-' + option.value"
        />
        <span class="multi-checkbox-label">{{ option.label }}</span>
      </label>
    }
    @if (checkboxOptions.length === 0) {
      <span class="multi-checkbox-empty">{{ 'formly.multiCheckbox.noOptions' | translate }}</span>
    }
  </div>
</div>
